module.exports = __webpack_public_path__ + "img/rafal-wawrzynek-1.c7ccfbd8.jpg";